import {Component, Input} from '@angular/core';

@Component({
  selector: 'cancelled-booking-banner',
  templateUrl: 'cancelled-booking-banner.html'
})
export class CancelledBookingBannerComponent {

  @Input() booking;

  constructor(

  ) {

  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/components/cancelled-booking-banner/cancelled-booking-banner.ts